// extracted by css-extract-rspack-plugin
export default {"LabelTooltip":"Label-module__LabelTooltip__M30br","tooltipHidden":"Label-module__tooltipHidden__vi354","linkHidden":"Label-module__linkHidden__WqjWi"};